module.exports = __webpack_public_path__ + "static/zama_libro_sintesis-cc633fb05a69b78aae5e64fa5a965236.jpg";